/**
 * Created by ren on 12/07/2017.
 */

import * as APIUtil from '../apiUtils';
import * as APICommon from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export const saveDoc = (app, params) => {
  const { user = {}, data } = params;

  const orderGroup = {
    doc_type: DocType.ORDER_GROUP,
    active: APIUtil.toBoolean(data.active),
    name: APIUtil.toStringText(data.name),
    description: APIUtil.toStringText(data.description),
  };

  return APICommon.saveDoc(app, { source: data, doc: orderGroup, user });
};

export const deleteDoc = (app, params) =>
  APICommon.deleteDoc(app, { id: params.id, docType: DocType.ORDER_GROUP });

export const fetchDocById = (app, params) => {
  const { id } = params;
  const docType = DocType.ORDER_GROUP;
  return APICommon.getDoc(app, { id, docType });
};
